<template>
  <div class="nav">
    <div class="with-divisor">
      v1.0.0 – made with 💙 by
      <a href="https://www.linkedin.com/in/lucasgmm/">Lucas Miranda</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.nav {
  text-align: center;
  font-family: "Roboto", sans-serif;
  color: #495057;
  font-size: 14px;
}

.with-divisor {
  padding: 60px 0 60px 0;
  margin: 0px 40px;
  border-top: 1px solid;
  border-color: #e4e5e8;
}
</style>
